import { MenuElement } from '@website-builder/widgets/menu/menu-element';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class MenuSection {
  id = makeEntityId(EntityIdPrefix.WIDGET_SECTION);
  items = new Array<MenuElement>(new MenuElement('list'));
}
